// extracted by mini-css-extract-plugin
export default {"infoCardDiv":"infoCard_infoCardDiv__1Eimi"};